<template>
    <Carousel class="profiles-carousel" :items="carouselItems" data-testid="profiles-carousel">
        <template #slide="{item, index}">
            <ProfileCard :profile="formatProfile(item)" :link-href="$withLocalePrefix(item.url)" :data-testid="`profiles-card-${index}`" />
        </template>
    </Carousel>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import type {Profile} from '@profile-card/types/index.js';
    import {ProfileCard} from '#components';
    import Carousel from './Carousel.vue';
    import type {FreelancerProfile} from '../../../types/cms-api';

    function formatProfile(profile: FreelancerProfile): Profile {
        return {
            ...profile,
            portfolio: [],
            skills: profile.skills?.map((skill) => skill.label),
            photoUrl: profile.photo?.absoluteUrl,
            price: {
                visibility: profile.price?.visibility,
                formattedValue: profile.price?.value?.formatted,
            },
        } as Profile;
    }

    const {items} = defineProps<{items: FreelancerProfile[]}>();

    const carouselItems = ref(items);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .profiles-carousel {
        .profile-card {
            height: 100%;

            .profile-location {
                white-space: unset;
            }
            .profile-name {
                color: var(--joy-color-neutral-0);
            }
        }
        .swiper-slide {
            padding-bottom: var(--joy-core-spacing-3);
        }
    }
</style>
